import React from 'react'
import {encodeFilters} from 'common/util/urlPresets.ts'
import {useNavigate} from 'react-router-dom'
import {BarChartOutlined} from '@ant-design/icons'
import { ListActionButton } from 'common/components/ListActionButton.tsx'

interface Props {
    title: string
    filterName: string
    id: number | undefined
}

export const GoToReportButton: React.FC<Props> = ({title, filterName, id}) => {
    const navigateTo = useNavigate()

    const onGoToRecord = (filterName: string, id: number | undefined) => {
        if (!id) {
            return;
        }

        const filtersJSON = {
            [filterName]: [id.toString()]
        };

        const searchParams = new URLSearchParams({
            filters: encodeFilters(filtersJSON),
            period: 'LAST_7_DAYS',
            autogen: '1'
        }).toString();

        navigateTo(`/report-builder?${searchParams}`);
    }

    return (
        <ListActionButton
            tooltip={title}
            onClick={() => onGoToRecord(filterName, id)}
        >
            <BarChartOutlined />
        </ListActionButton>
    )
}
